import useComputed from '@/hooks/use-computed'
import api from '@/services/api/dataDictionary'
import { useState, useRef } from 'react'
import { orderBy } from 'lodash'
import KeyHelper from '@/utils/key-helper'

export function serialize(entry) {
    return {
        dataElementId: entry.dataElementId,
        classification: entry.classification,
        dataElementName: entry.dataElementName,
        description: entry.description,
        fields: entry.fields,
        useCase: orderBy(entry.useCase, ["useCaseName"], ['asc'])
    }
}

export function serializeClassifications(entry) {
    let name = "All (Default)";
    let value = "ALL";
    if (entry === "DOCUMENT") {
        name = "Document"
        value = "DOCUMENT"
    }

    if (entry === "EVENT") {
        name = "Event"
        value = "EVENT"
    }

    return {
        name,
        value
    }
}

export function serializeUseCasesLists(entry) {
    return {
        id: entry.useCaseId,
        label: entry.useCaseName,
        value: entry.useCaseId,
        $selected: true
    }
}

export function setInitialDataForFields(classificationsList, response, setClassificationsLists, setUseCasesLists) {
    if (classificationsList.length === 0) {
        response.items.dataElementClassification = ["ALL (Default)", ...response.items.dataElementClassification]
        setClassificationsLists(response.items.dataElementClassification.map(entry => serializeClassifications(entry)))
        setUseCasesLists(response.items.useCases.map(entry => serializeUseCasesLists(entry)))
    }
}

const useDataDictionary = () => {

    const [error, setError] = useState()
    const [loading, setLoading] = useState(false)
    const [items, setItems] = useComputed([])
    const [allData, setAllData] = useState();
    const [dataElementDetails, setDataElementDetails] = useComputed([])
    const [useCasesLists, setUseCasesLists] = useState([])
    const [classificationsList, setClassificationsLists] = useState([])

    const lastRequestPayloadKeyRef = useRef(null)

    async function fetchDataDictionaryLists(params) {
        const currentPayloadKey = KeyHelper.createKeyOfObject({ params })

        if(KeyHelper.isSameKey(lastRequestPayloadKeyRef.current, currentPayloadKey)) return;

        lastRequestPayloadKeyRef.current = currentPayloadKey

        const [err, response] = await api.index(params);
        if (err) {
            return setError("Error in getting Data Dictionary Lists");
        }
        setAllData(response.data.meta);
        setItems(response.data.items.data.map(entry => serialize(entry)))
        setInitialDataForFields(classificationsList, response.data, setClassificationsLists, setUseCasesLists)
    }

    async function fetchDataDictionaryDetails(params) {
        setLoading(true)
        const [err, response] = await api.indexDetails(params);
        setLoading(false)
        if (err) {
            return setError("Error in getting Data Dictionary Details");
        }
        setDataElementDetails(response)
        return response.fields
    }

    return {
        error,
        fetchDataDictionaryLists,
        fetchDataDictionaryDetails,
        loading,
        items,
        allData,
        dataElementDetails,
        setDataElementDetails,
        useCasesLists,
        classificationsList
    }

}

export default useDataDictionary
